import { CampaignType } from "@/@types/gamification";

export const PRO015_DESCRIPTION_MAX = 40;

export const CAMPAIGN_TYPE_PREFIX: Record<CampaignType, string> = {
  [CampaignType.ROULETTE]: "Roleta",
  [CampaignType.SCRATCH]: "Raspadinha",
  [CampaignType.SLOT]: "Caça-Níquel",
  [CampaignType.PENALTY]: "Chutou Ganhou",
};

export function maxCampaignNameLength(type: CampaignType): number {
  return PRO015_DESCRIPTION_MAX - (CAMPAIGN_TYPE_PREFIX[type].length + 1);
}

export const CUSTOMER_FACING_NAME_MAX = 80;

export const CUSTOMER_FACING_DESCRIPTION_MAX = 140;
